// extracted by mini-css-extract-plugin
export default {"zoomModal":"z5-z","image":"A5-z","button":"B5-z","isOverlayShown":"C5-z"};